export default __webpack_public_path__ + "static/media/landing_image_2.6f615b69.png";